import { formatDate } from 'element-ui/src/utils/date-util'

export default formatDate
